import { render, staticRenderFns } from "./words.vue?vue&type=template&id=4dd3d823&scoped=true&"
import script from "./words.vue?vue&type=script&lang=js&"
export * from "./words.vue?vue&type=script&lang=js&"
import style0 from "./words.vue?vue&type=style&index=0&id=4dd3d823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd3d823",
  null
  
)

export default component.exports